// extracted by mini-css-extract-plugin
export default {"advtWrapper":"Advt_advtWrapper__BUqgf","title":"Advt_title__WULbl","wiggle":"Advt_wiggle__zLwoi"};